import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=ca4f9cfc&scoped=true&"
import script from "./RuleForm.vue?vue&type=script&lang=tsx&"
export * from "./RuleForm.vue?vue&type=script&lang=tsx&"
import style0 from "./RuleForm.vue?vue&type=style&index=0&id=ca4f9cfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4f9cfc",
  null
  
)

export default component.exports